var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"header-title mb-3"},[_vm._v("Flights")]),_c('div',{staticClass:"chartjs-chart"},[_c('barChart',{attrs:{"height":260,"pilotData":_vm.pilotData}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }